import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import {FormMasterItemConfigurationModel} from '../../../../models/forms/form-master-item-configuration.model';
import {EnumValidValueModel} from '../../../../models/enum/enum-valid-value.model';
import {FormItemConfigurationModel} from '../../../../models/forms/form-item-configuration.model';
import {FormParagraphConfigurationModel} from '../../../../models/forms/form-paragraph-configuration.model';
import {FormVersionConfigurationModel} from '../../../../models/forms/form-version-configuration.model';
import {FormConfigurationModel} from '../../../../models/forms/form-configuration.model';
import {FormItemActionConfigurationModel} from '../../../../models/forms/form-item-action-configuration.model';
import {UserService} from '../../../../services/user.service';
import {FormDeleteResponseModel} from '../../../../models/forms/form-delete-response.model';

@Injectable({
  providedIn: 'root'
})
export class FormsBuilderPolishedService {
  constructor(
    private http: HttpClient
  ) {}

  getCfgFormSimpleList(): Observable<any[]> {
    return this.http.get<any[]>('/api/forms/getCfgFormList', UserService.authorizationHeaderObject);
  }

  getNewGuids(count: number): Observable<any[]> {
    return this.http.get<any[]>(`/api/forms/getNewGuids/${count}`, UserService.authorizationHeaderObject);
  }

  saveDuplicateCfgVersion(cfgVersion: FormVersionConfigurationModel): Observable < FormConfigurationModel > {
    return this.http.post<FormConfigurationModel>('api/forms/saveDuplicateCfgVersion', cfgVersion, UserService.authorizationHeaderObject);
  }

  saveDuplicatedCfgDForm(cfgDForm: FormConfigurationModel): Observable<FormConfigurationModel> {
    return this.http.post<FormConfigurationModel>('api/forms/saveDuplicatedCfgDForm', cfgDForm, UserService.authorizationHeaderObject);
  }

  searchForFormByKeyword(keyword: string): Observable<any[]> {
    return this.http.post<any>('/api/forms/searchForFormByKeyword', { keyword }, UserService.authorizationHeaderObject);
  }

  setBuilderForm(form: any) {
    localStorage.setItem('builder-form', JSON.stringify(form));
  }

  clearBuilderForm() {
    localStorage.removeItem('builder-form');
  }

  getBuilderForm() {
    return JSON.parse(localStorage.getItem('builder-form'));
  }

  getAllValidValues(): Observable<EnumValidValueModel[]> {
    return this.http.get<EnumValidValueModel[]>('/api/valid-values-v2/getValidValues', UserService.authorizationHeaderObject);
  }

  getAllActions(): Observable<FormItemActionConfigurationModel[]> {
    return this.http.get<FormItemActionConfigurationModel[]>('/api/forms/getActions', UserService.authorizationHeaderObject);
  }

  saveCfgDForm(cfgForm: FormConfigurationModel): Observable<FormConfigurationModel> {
    return this.http.post<FormConfigurationModel>('/api/forms/saveCfgForm', cfgForm, UserService.authorizationHeaderObject);
  }

  deleteCfgForm(DFormId: string) {
    return this.http.get<FormDeleteResponseModel>(`/api/forms/delete-cfg-form/${DFormId}`);
  }

  saveCfgFormVersion(cfgVersion: FormVersionConfigurationModel): Observable<FormVersionConfigurationModel> {
    return this.http.post<FormVersionConfigurationModel>('/api/forms/saveCfgFormVersion', cfgVersion, UserService.authorizationHeaderObject);
  }

  saveCfgParagraph(cfgParagraph: FormParagraphConfigurationModel): Observable<FormParagraphConfigurationModel> {
    return this.http.post<FormParagraphConfigurationModel>('/api/forms/saveCfgParagraph', cfgParagraph, UserService.authorizationHeaderObject);
  }

  saveCfgItem(cfgItem: FormItemConfigurationModel): Observable<FormItemConfigurationModel> {
    return this.http.post<FormItemConfigurationModel>('/api/forms/saveCfgItem', cfgItem, UserService.authorizationHeaderObject);
  }

  saveCfgMasterItem(cfgMasterItem: FormMasterItemConfigurationModel): Observable<FormMasterItemConfigurationModel> {
    return this.http.post<FormMasterItemConfigurationModel>('/api/forms/saveCfgMasterItem', cfgMasterItem, UserService.authorizationHeaderObject);
  }
}
